import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import './icons'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import animated from 'animate.css';
import recorderView from './components/recorder/index.vue'
import audio from 'vue-mobile-audio'
Vue.use(audio)
Vue.component('recorder-view', recorderView)
Vue.use(ElementUI);
Vue.config.productionTip = false;

Vue.use(animated);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
